import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgcPipesModule } from '../pipes/module';
import { ContentBodyService } from '../services/content/contentbody.service';
import { NgcCalendarDirective } from './calendar.directive';
import { ContentBodyComponent } from './content-body/content-body.component';
import { CreditCardTypeIdentifierDirective } from './creditcardvalidator-directive/creditcardtypeidentifier.directive';
import { FloatingLabelDirective } from './floatinglabel-directive/floatinglabel.directive';
import { KeyboardFocusDirective } from './keyboard-focus-directive/keyboard-focus-directive';
import { NgcSelectDirective } from './select.directive';

const NGC_COMMON_DIRECTIVES = [
  NgcCalendarDirective,
  NgcSelectDirective,
  FloatingLabelDirective,
  ContentBodyComponent,
  CreditCardTypeIdentifierDirective,
  KeyboardFocusDirective
];

@NgModule({
  imports: [NgcPipesModule, CommonModule, ModalModule.forRoot()],
  declarations: [NGC_COMMON_DIRECTIVES],
  exports: [NGC_COMMON_DIRECTIVES],
  providers: [ContentBodyService]
})
export class NgcCommonModule {}
